'use es6';

import { createSelector } from 'reselect';
import { getTabsOrder } from './tabs';
export const getHasUsedCos = state => state.onboarding.hasUsedCos;
export const getHasUserOnboarded = state => state.onboarding.hasOnboardedIDE;
export const getIsFetching = state => state.onboarding.fetching;
export const getHasFinishedFetching = state => state.onboarding.doneFetching;
export const getHasSeenWelcomeTab = state => state.onboarding.hasSeenWelcomeTab;
export const getShowStarterDowngradeNotice = state => state.onboarding.showStarterDowngradeNotice;
export const shouldShowStarterDowngradeForPortal = state => {
  const showStarterDowngradeNotice = getShowStarterDowngradeNotice(state);
  const portalId = state.auth.portal.portal_id;
  return showStarterDowngradeNotice.includes(portalId);
};
export const makeGetShouldShowGettingStartedTab = () => {
  let wasGettingStartedTabOpen = false;
  return createSelector([getHasFinishedFetching, getHasSeenWelcomeTab, getTabsOrder], (hasFinishedFetching, hasSeenWelcomeTab, tabsOrder) => {
    /* keep it as true once it's seen */
    if (!wasGettingStartedTabOpen) {
      const tabId = 'gettingStarted';
      wasGettingStartedTabOpen = tabsOrder[0] === tabId;
    }

    return hasFinishedFetching && !hasSeenWelcomeTab && !wasGettingStartedTabOpen;
  });
};